var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "unidadCompuesta" } },
    [
      _c("route-breadcrumb", {
        attrs: { routes: _vm.rutas, "ends-file": true },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "py-5" }, [
        _c("div", { staticClass: "container is-fluid" }, [
          _c(
            "h1",
            { staticClass: "title is-3 is-marginless is-hidden-touch" },
            [
              _c("i", { staticClass: "far fa-file-archive" }),
              _vm._v(
                "\n         " +
                  _vm._s(
                    _vm.unidadCompuesta.nombre &&
                      _vm.unidadCompuesta.nombre.length > 50
                      ? _vm.unidadCompuesta.nombre.substring(0, 50) + "..."
                      : _vm.unidadCompuesta.nombre
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "h5",
            { staticClass: "title is-4 is-marginless is-hidden-desktop" },
            [
              _c("i", { staticClass: "far fa-file-archive fa-lg" }),
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.unidadCompuesta.nombre &&
                      _vm.unidadCompuesta.nombre.length > 50
                      ? _vm.unidadCompuesta.nombre.substring(0, 50) + "..."
                      : _vm.unidadCompuesta.nombre
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.eventoEnEjecucion
            ? _c("div", { staticClass: "notification is-primary" }, [
                _c("i", { staticClass: "fas fa-forward" }),
                _vm._v(" \n        "),
                _c("b", [_vm._v("ATENCIÓN:")]),
                _vm._v(" Existe un evento en proceso en esta unidad.\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box is-clearfix" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "tags is-pulled-right is-marginless" }, [
              _vm.eventoEnEjecucion
                ? _c(
                    "span",
                    {
                      staticClass:
                        "tag is-warning is-medium animated flash slower infinite",
                    },
                    [
                      _c("i", { staticClass: "fas fa-clock" }),
                      _vm._v(" Evento en ejecución"),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "tag is-primary is-medium" }, [
                _vm._v(
                  _vm._s(
                    _vm.unidadCompuesta.serie_documental.estados[
                      _vm.unidadCompuesta.estado
                    ]
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                !_vm.eventoEnEjecucion
                  ? _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("CorrerEvento", {
                          on: { updateDocument: _vm.updateDocument },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userIsResponsable && _vm.eventoEnEjecucion
                  ? _c(
                      "div",
                      { staticClass: "box animated flash slow" },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _vm._l(
                          _vm.accionesEventoEnEjecucion,
                          function (accion) {
                            return _c("accion-evento", {
                              key: accion.id,
                              attrs: { accion: accion },
                              on: { updateDocument: _vm.updateDocument },
                            })
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.userIsResponsable && _vm.eventoEnEjecucion
                  ? _c("div", { staticClass: "notification is-warning" }, [
                      _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                      _vm._v(
                        " Hay un evento en ejecucion iniciado por otro usuario\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [_vm._m(3), _vm._v(" "), _c("historial-ejecuciones")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [_vm._m(4), _vm._v(" "), _c("informacion")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._l(_vm.unidadCompuesta.aspectos, function (aspecto) {
                      return _c("metadatos", {
                        key: `asp-meta-${aspecto.id}`,
                        attrs: {
                          "force-edit": false,
                          "hide-save-button": true,
                          metadatos: _vm.unidadCompuesta.lista_metadatos,
                          aspecto: aspecto,
                          "read-only": true,
                          "can-edit": false,
                        },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("permisos", {
                  attrs: {
                    documento: _vm.unidadCompuesta,
                    "nivel-permiso-user": _vm.nivelPermisoUser,
                  },
                  on: { updateDocument: _vm.updateDocument },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.openSideBySide
              ? _c("div", { staticClass: "column is-4" }, [
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("SubunidadesCargadas", {
                        on: { "side-by-side": _vm.toggleSideBySide },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [_c("InformacionSerieDocumental")],
                    1
                  ),
                ])
              : _c("div", { staticClass: "column is-6 pl-0" }, [
                  _c("div", { staticClass: "is-flex file-side-to-side" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            _vm.openSideBySide = false
                          },
                        },
                      },
                      [
                        _c(
                          "b-tooltip",
                          { attrs: { label: "Cerrar", position: "is-left" } },
                          [
                            _c("i", {
                              staticClass: "fas fa-lg fa-angle-double-right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("iframe", {
                      attrs: { src: _vm.urlPreviewer, frameborder: "0" },
                    }),
                  ]),
                ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass:
          "subtitle is-5 has-text-primary is-pulled-left is-marginless",
      },
      [
        _c("i", { staticClass: "fas fa-info-circle" }),
        _vm._v(" Estado actual\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      { staticClass: "subtitle is-5 has-text-primary is-marginless" },
      [
        _c("i", { staticClass: "fas fa-info-circle" }),
        _vm._v(" Eventos disponibles para ejecutar"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Acciones a realizar\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Historial\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Información\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Metadatos"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box mb-0" }, [
      _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
        _c("i", { staticClass: "fas fa-users-cog" }),
        _vm._v(" Permisos"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "far fa-file" }),
      _vm._v(" Subunidades\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }